import { createRouter, createWebHistory } from 'vue-router'
import { moduleRoutes } from '@/register-modules'

const routes = [
  {
    path: '/',
    component: () => import('@/components/AppShell.vue'),
    children: [
      {
        path: '',
        redirect: '/rules',
      },
      ...moduleRoutes,
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
